const FranceTranslation = {
  translation: {
    popup: {
      buttons: {
        next: 'Suivant',
        end: 'Fermer',
        prev: 'Précédent',
      },
    },
    onboarding: {
      label: "J'ai compris",
      register: {
        steps: {
          one: {
            titleBlue_1: 'MonAvisLeRend',
            titlePink_1: 'Bienvenue sur',
            titlePink_2: 'Gratuit',
            claim_1: '\u202F🎉\u202FDéjà plus de **330 000 utilisateurs** se sont inscrits à notre programme.',
            claim_2: "\u202F💶\u202F**9 millions €** en produits **GRATUITS** ont été offerts l'année dernière.",
            claim_3: '\u202F👇\u202FVoici comment ça fonctionne.',
          },
          two: {
            title: 'Vos produits gratuits vous attendent',
            claim: 'Demandez votre coupon, retirez votre produit en magasin, partagez votre expérience.',
            next: 'Je commence',
          },
        },
      },
      promotions: {
        steps: {
          one: {
            title: ', découvrez vos produits gratuits\u202F!',
            claim_1:
              'Parcourez les produits disponibles dans votre magasin, et filtrez pour trouver plus vite ceux qui vous plaisent.',
          },
          two: {
            title: 'Gérez votre profil',
            claim_1: 'Cliquez sur vos initiales pour\u202F:',
            claim_2: ' &bull; Mettre à jour votre profil et accéder à des produits faits pour vous.',
            claim_3: ' &bull; Changer de magasin ou ajouter votre carte Carrefour.',
            next: "J'ai compris",
          },
        },
      },
      promotion: {
        steps: {
          one: {
            title: "Pas d'enquête pour le premier produit\u202F!",
            claim_1:
              'Rien à remplir cette fois-ci\u202F! Lors de votre prochain coupon, une courte enquête vous sera demandée.',
          },
        },
      },
      promotionDetail: {
        steps: {
          one: {
            title: 'Détails du coupon',
            claim_1: 'Avant de demander un produit\u202F:',
            claim_2: '**Crédits**\u202F: \u202FConsultez les crédits nécessaires',
            claim_3: '**Jours**\u202F: \u202FVérifiez la date limite',
            claim_4: '**Informations**\u202F: \u202FLocalisez le produit en magasin',
          },
        },
      },
      promotionPost: {
        steps: {
          one: {
            title: 'Vos coupons et crédits',
            claim_1:
              'Retrouvez ici vos coupons pour les présenter en magasin et retirer les produits. Laissez ensuite votre avis pour récupérer vos crédits et recommencer.',
          },
        },
      },
      favorites: {
        button: "J'ai compris",
        stepOne: {
          title: 'Bien vu, {{name}}\u202F!\u202F🎉',
          claim_1: 'Ce produit a été ajouté à vos favoris. Retrouvez-le dans le Menu en haut de la page.',
          claim_2: 'Utilisez la flèche ⬆️ en bas à droite pour y accéder rapidement.',
        },
        stepTwo: {
          title: 'Vos produits favoris',
          claim_1: 'Retrouvez tous vos produits favoris dans ce Menu.',
          claim_2: '⚠️ Seuls les produits encore disponibles y apparaissent.',
        },
      },
    },
    common: {
      OR: 'or',
      upToDate: ' ',
      visitSite: 'Go to the site',
      assessment: {
        excellent: 'Excellent',
        veryGood: 'Very good',
        good: 'Good',
        acceptable: 'Acceptable',
        bad: 'Bad',
      },
      back: 'Back',
      cancel: 'Cancel',
      send: 'Send',
      credits: 'crédits',
      day: '{{n}} día',
      days: '{{n}} días',
      today: 'hoy',
      tomorrow: 'mañana',
    },
    user: {
      anonymous: 'Utilisateur de MonAvisLeRendGratuit',
    },
    validation: {
      error: {
        invalidEmail: 'Invalid email format',
        required: 'This field is required',
        passwordMismatch: 'Password does not match',
        notification: 'Code d’erreur :',
        InvalidNameException:
          "Votre prénom client est manquant ou n'est pas valide. Veuillez vérifier vos données personnelles dans votre compte Carrefour et réessayer.",
        InvalidLastNameException:
          "Votre nom client est manquant ou n'est pas valide. Veuillez vérifier vos données personnelles dans votre compte Carrefour et réessayer.",
        genericLoginError: "La connexion à votre compte Carrefour n'a pas pu être établie",
        register:
          "Un problème technique est survenu. Si cela persiste, veuillez envoyer au Service Client de MonAvisLeRendGratuit une capture d'écran de cette erreur.",
      },
    },
    option: {
      gender: {
        choose: 'Choose one',
        MALE: 'Man',
        FEMALE: 'Woman',
        NOT_ANSWERED: '-',
      },
      policies: {
        platformCommunications: 'Platform Communications',
        retailerCommunications: 'Retailer Communications',
        dataLinkWithSAZ: 'Link profile with ShopAdvizor',
        thirdPartyCommunications: 'Third Party Communications',
      },
      educationLevel: {
        0: 'Level 0: Pre-primary education',
        1: 'Level 1: Primary education or first stage of basic education',
        2: 'Level 2: Lower secondary education or second stage of basic education',
        3: 'Level 3: Upper secondary education',
        4: 'Level 4: Post-secondary non-tertiary education',
        5: 'Level 5: Short-cycle tertiary education',
        6: "Level 6: Bachelor's or equivalent",
        7: "Level 7: Master's or equivalent",
        8: 'Level 8: Doctoral or equivalent',
      },
      yesOrNot: {
        YES: 'Yes',
        NO: 'No',
        NOT_ANSWERED: '-',
      },
      preference: {
        alcohol: 'Alcohol',
        bio: 'Bio',
        light: 'Light',
        noGluten: 'Without gluten',
      },
      numberOfHomeComponent: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        '5+': 'More than 5',
      },
    },
    forms: {
      shuffle: {
        success: 'Merci pour votre commentaire !',
        successRemaining: 'Merci pour votre commentaire, évaluez encore {{number}} {{item}} pour continuer !',
        successContinue: 'Merci pour votre commentaire, cliquez sur continuer pour finaliser',
        singular: 'produit',
        plural: 'produits',
        placeholder: {
          title: "Quel est l'élément le plus important ?",
          comment:
            "Partagez votre expérience avec ce produit : qu'avez-vous le plus apprécié ou le moins apprécié et pourquoi ? Parlez-nous des détails, de son utilisation et de ses caractéristiques.",
        },
        label: {
          title: 'Ajoutez un titre à votre évaluation',
          comment: 'Rédigez votre évaluation',
          nps: 'À quel point recommanderiez-vous ce produit ?',
          rating: 'Note générale',
          submit: 'Envoyer',
          stars: 'Quelle note de 1 à 5 donneriez-vous à ce produit ?',
          afterStars: 'Votre avis sincère est important, il sera partagé pour aider les autres consommateurs.',
          next: 'Suivant',
        },
        validation: {
          title: {
            min: 'Rédigez un titre d’au moins 5 caractères',
          },
          comment: {
            min: 'Rédigez un avis d’au moins 25 caractères',
          },
          nps: {
            required: 'Veuillez choisir une note comprise entre 1 et 10',
          },
          rating: {
            required: 'Veuillez choisir une note comprise entre 1 et 5',
          },
        },
        continue: {
          singular: 'Évaluez 1 produit pour continuer',
          plural: 'Évaluez {{n}} produits pour continuer',
          submit: 'Continuer',
        },
        submitting: {
          duplicated: 'Vous avez déjà évalué ce produit',
        },
      },
      signIn: {
        caption: 'Log in MonAvisLeRendGratuit (Monavis)',
        label: {
          username: 'Email',
          password: 'Mot de passe',
        },
        placeholder: {
          username: 'Your email',
          password: 'Mot de passe',
        },
        cta: {
          signUp: 'Create your account',
          resetPass: 'Forgot password?',
          monavis: 'Connect through Monavislerendgratuit.com',
          submit: 'Me connecter',
        },
        error: {
          invalid: 'Unable to login, check credentials',
          network: 'Network error',
        },
      },
      signUp: {
        caption: 'Sign Up',
        label: {
          email: 'Email',
          emailRepeat: 'Email Repeat',
          password: 'Password',
          passwordRepeat: 'Password Repeat',
          firstName: 'First Name',
          lastName: 'Last Name',
          gender: 'Gender',
          birthDate: 'Date of birth',
          phoneNumber: 'Phone number',
          mailAgreement: 'Yes, i want to receive in my email promotions, offers and other info from shopadvizor.com ',
          policyAgreement: 'Yes, i accept conditions.',
        },
        placeholder: {
          email: 'Your email',
          emailRepeat: 'Repeat email',
          password: 'Your password',
          passwordRepeat: 'Repeat password',
          firstName: 'Your firstname',
          lastName: 'Your lastname',
          gender: 'Your gender',
          birthDate: 'Your birthdate',
          phoneNumber: 'Your phone number',
        },
        cta: {
          logIn: 'Already registered?, Log in',
          submit: 'Create your account',
        },
        error: {
          network: 'Network error',
        },
      },
      profile: {
        headers: {
          policies: 'Policies',
          preferences: 'Preferences',
          education: 'Education',
          couple: 'Couple',
          pet: 'Pet',
        },
        label: {
          gender: 'Gender',
          partnerGender: 'Gender',
          partnerFirstName: 'First Name',
          partnerBirthDate: 'Birth date',
          numberOfHomeComponents: 'Number of home components',
          state: 'State',
          city: 'City',
          zipCode: 'Zip code',
          line1: 'Address',
          line2: 'Address complementary',
          hasPartner: 'hasPartner',
          hasPet: 'hasPartner',
          educationLevelCode: '',
          birthDate: 'Date of birth',
        },
        placeholder: {
          gender: 'Gender',
          partnerGender: 'Your partner gender',
          partnerFirstName: 'Your partner firstname',
          partnerBirthDate: 'Your partner lastname',
          numberOfHomeComponents: 'Number of people who you live with',
          state: 'State',
          city: 'City',
          zipCode: 'Zip code',
          line1: 'Enter your address',
          line2: 'Enter your additional info',
          hasPartner: 'Do you have a partner?',
          hasPet: 'Do you have a pet?',
          educationLevelCode: 'What are your educational level?',
          birthDate: 'Date of birth',
        },
        cta: {
          logIn: 'Already registered?, Log in',
          submit: 'Create your account',
        },
        error: {
          network: 'Network error',
        },
      },
      photo: {
        description: {
          title: 'Change your avatar image',
          subtitle1: 'It must be jpg,png',
          subtitle2: 'it must be below 2.5M',
        },
        cta: {
          add: 'Add photo',
          edit: 'Edit photo',
          delete: 'Delete photo',
        },
        caption: {
          file: 'Change your avatar',
          submit: 'Save changes',
        },
        notification: {
          success: 'Your photo has changed',
          error: 'Error, connection failed',
        },
      },
      resetPassword: {
        caption: 'Forgot your password?',
        captionError: 'Not valid token.',
        label: {
          email: 'Email',
        },
        placeholder: {
          email: 'Your email',
        },
        notification: {
          success: 'We’ve sent an email with a link to reset your password.',
          error: 'Error, connection failed',
        },
        cta: {
          submit: 'Send reset-password link',
          back: 'Back to login',
        },
      },
      confirmPassword: {
        caption: 'Forgot your password?',
        captionError: 'Not valid token.',
        label: {
          password: 'Password',
          confirm: 'Confirm password',
        },
        placeholder: {
          password: 'Enter your new password',
          confirm: 'Confirm your new password',
        },
        notification: {
          success: 'Your password has changed',
          error: 'Error, connection failed',
        },
        cta: {
          submit: 'Send',
        },
      },
      commentCreate: {
        cta: {
          leaveComment: 'Create a review',
        },
        error: {
          noRate: 'You must rate the product',
          commentBelowMinimum: 'Minimal comment length 10 characters.',
        },
      },
      products: {
        search: 'Rechercher un produit',
      },
    },
    pages: {
      confirmEmail: {
        caption: 'Confirm your email',
        success: {
          title: 'Your email has been confirmed!',
          text: '',
        },
        error: {
          title: 'Your email has not been confirmed!',
        },
      },
      productDetail: {
        caption: {
          ctaToolTipStarsBefore: 'Hey, hey,',
          ctaToolTipStarsAfter: 'you can touch the stars!',
          ingredients: 'Ingredients',
          allergens: 'Allergens',
          description: 'Description',
          nutrients: 'Nutrients',
          moreInfo: 'More information',
          ratingDetails: 'Rating details',
          productRating: 'Current product rating',
          userReviews: 'User reviews',
          nutriscore: 'About nutriscore',
          range: 'Nutrients range',
          totalReviews: '(Total reviews)',
        },
        texts: {
          ratingDetails:
            'Basically, the nutritional value for the our grade is determined by subtracting the total ' +
            'positive points from the total negative points. And the lower the score, the better the letter grade.',
          nutriscore:
            'Voici comment est attribué le Nutri-Score, un algorithme attribue des points à chaque élément repris dans le ' +
            'tableau des valeurs nutritionnelles (par 100 g ou 100 ml), tant pour les substances alimentaires bénéfiques ' +
            'affichant un score négatif (protéines, fibres, quantité de fruits, de légumes, de fruits à coque, d&apos;huile ' +
            'de colza, d&apos;huile de noix et d&apos;huile d&apos;olive) que pour les substances alimentaires moins ' +
            'bénéfiques affichant un score positif (haute valeur énergétique [kJ], sucres, acides gras saturés, sel).' +
            'Ensuite, les points positifs (moins bénéfiques, donc) sont déduits des points négatifs (bénéfiques) et le' +
            'résultat est converti dans le tableau du Nutri-Score. ',
        },
      },
      additionalCredits: {
        title: 'Mes crédits additionnels',
        subtitle:
          'Vous trouverez ici toutes les informations correspondantes aux crédits additionnels que vous avez obtenus grâce à votre participation à la Communauté Carrefour.',
        noCredits:
          "Vous n'avez pas encore de crédits additionnels. Participez à la Communauté Carrefour en complétant les missions et augmentez ainsi votre cagnotte de crédits !",
        startDate: 'Début de validité:',
        endDate: "Date d'expiration:",
        status: {
          programmed: 'À venir',
          available: 'Disponibles',
          expired: 'Expirés',
        },
        nextPage: 'Page suivante',
        prevPage: 'Page précédente',
      },
      unsub: {
        title: 'Désinscription',
        placeholder: 'Raison de votre désinscription',
        placeholder_technical: 'Quels problèmes avez-vous rencontrés ?',
        placeholder_mix: 'Quels problèmes avez-vous rencontrés ou quelle est la raison de votre désinscription ?',
        subtitle: 'Veuillez nous indiquer les raisons de votre désinscription :',
        errorTxt: 'Veuillez indiquer le motif de désinscription',
        errorTxtTechnical: 'Veuillez indiquer les problèmes rencontrés',
        errorTxtMix: 'Veuillez détailler les problèmes rencontrés ou votre motif de désinscription.',
        errorCheck: 'Veuillez indiquer au moins un motif de désinscription',
        errorTxtMin: 'Minimum 10 caractères',
        ok: 'Votre désinscription a correctement été prise en compte.',
        submit: 'Confirmer',
      },
      promotions: {
        router: {
          postSurveySuccess: 'Gracias por completar la encuesta',
          createCouponSuccess: 'Tu cupón se ha generado correctamente. Podrás verlo en la sección de Mis Cupones',
          error: 'Lo sentimos, ha ocurrido un error, por favor, intentalo más tarde',
          creating: 'Estamos creando tu cupón, por favor espera unos segundos',
          alreadyAnswered: 'Ha ocurrido un problema al acceder a tu encuesta. Inténtalo más tarde.',
          loading: 'Cargando, un momento por favor...',
        },
        menu: {
          available: 'Promociones disponibles',
          availableMobile: 'Promociones',
          coupons: 'Mis cupones',
          couponsMobile: 'Cupones',
          couponsHistory: 'Histórico de cupones',
          orders: 'Recuperar sazcoins',
          ordersMobile: 'Recuperar',
          profile: 'Mi perfil',
          history: 'Histórico',
          credits: 'Saldo de sazcoins',
          closeSession: 'Cerrar sesión',
          totalCredits: 'sazcoins',
        },
        list: {
          title: '¿Qué productos quieres llevarte hoy?',
          activePromotion: {
            plural: '{{total}} promociones activas',
            singular: 'Una promoción activa',
          },
          showingQuantity: 'Mostrando {{showing}} de {{total}} promociones',
          showMore: 'Mostrar más',
          filter: {
            placeholder: 'Selecciona para filtrar',
            selectedAvailable: 'Disponibles en {{name}} ({{total}})',
            restAvailable: 'Resto de promociones ({{total}})',
          },
          noItems: 'No hay promociones disponibles para tu perfil en este momento. Vuelve en los próximos días.',
        },
        card: {
          redemptionPoint: {
            availableRetailers: '¿Dónde quieres ir a buscar tu producto?',
            selectRetailer: 'Selecciona uno de los siguientes puntos de canje',
            availableToRedeem: 'Disponible para retirar a partir del',
            availableToRedeemExtra: 'a las 12hs',
            redeemBefore: 'Tienes tiempo para ir a recogerlo hasta el',
            warning: 'Después de esta fecha, tu producto ya no podrá ser retirado.',
          },
          homeDeliveryTerms:
            'Esta promoción es de envío a domicilio. La empresa de transporte se pondrá en contacto contigo para hacerte llegar el producto. Una vez lo recibas, y pasadas unas horas, podrás evaluarlo en las sección de Recuperar sazcoins.',
          destinyData: 'Datos de envío',
          homeDelivery: {
            savedTo: 'Nombre completo',
            identifier: 'Número de identidad',
            telephone: 'Número de teléfono',
            address: 'Dirección completa',
            edit: 'Editar los datos',
          },
          conditions: 'Términos y condiciones',
          validUntil: 'Promoción válida hasta',
          validUntilWhenNoEndDate: 'Finalizar existencias',
          validUntilExtraText: '(o hasta finalizar existencias)',
          redeemBefore: 'El pedido vence',
          redeemBeforeExtraText: '(si realiza la solicitud hoy)',
          availableRetailers: 'Sólo disponible en',
          requestCoupon: 'Solicitar cupón',
          loadingRequest: 'Cargando, por favor, espera',
          selectRetailer: 'Elige un punto de canje',
          legalText:
            ' Para beneficiarse de esta promoción, debe realizar una compra minima de 30€. Puede utilizar un máximo de 4 cupones diferentes por compra realizada.',
          credits: 'sazcoins',
          activePromotions: 'Promociones Activas',
          loginMessage: 'Para beneficiarte de la promoción has de estar logueado.',
          noAccess: 'No se puede acceder a este contenido',
          couponCode: 'Código de cupón',
          evaluate: 'Opinar',
          expired: 'Expirado',
          exchange: 'Canjear',
          coupons: 'Mis Cupones',
          free: 'Gratis',
          tooltipText: 'Elige uno de estos puntos de canje',
        },
        labels: {
          noStock: 'Épuisé',
          lastUnits: 'Últimas',
          tooltipRetailerUnavailable:
            'Esta promoción está agotada en este punto de canje. La podrás retirar en otros en los que haya stock.',
        },
        concepts: {
          createOrder: 'Demande: {{name}}',
          cancelOrder: 'Annulation: {{name}}',
        },
        errors: {
          default:
            'Un problème est survenu avec votre compte utilisateur, veuillez prendre contact avec le Service Client.',
          noStock:
            "Le stock de ce produit est épuisé au sein du programme MonAvisLeRendGratuit. Cliquez sur Produits à tester pour découvrir d'autres produits disponibles.",
          limitRequested: 'Vous ne pouvez pas demander plus de 4 produits.',
          alreadyRequested: 'Il existe déjà une demande pour ce produit.',
          promotionInactive: 'Ce produit n’est plus disponible.',
          retailerNotFound:
            'El punto de canje seleccionado ya no está disponible. Por favor prueba seleccionando otro distinto.',
          retailerNoStock:
            "Le stock de ce produit est épuisé au sein du programme MonAvisLeRendGratuit. Cliquez sur Produits à tester pour découvrir d'autres produits disponibles.",
          noCredits: 'Oups ! Vous ne disposez pas de suffisamment de crédits pour demander ce produit.',
        },
        tooltip: {
          today: 'A retirar hoy',
          tomorrow: 'Último día para retirar el producto es mañana',
          days: 'A retirar antes de {{n}} días',
        },
      },
      po30: {
        rating: {
          label: 'Note générale',
          subtitle: 'Quelle note de 1 à 5 donneriez-vous à ce produit ?',
          belowText: 'Votre avis sincère est important, il sera partagé pour aider les autres consommateurs.',
          error: 'Notez en sélectionnant les étoiles',
        },
        nps: {
          label: 'À quel point recommanderiez-vous ce produit ?',
          error: 'Vous devez choisir une note comprise entre 1 et 10',
        },
        title: {
          label: 'Ajoutez un titre à votre évaluation',
          placeholder: "Quel est l'élément le plus important ?",
          error: 'Rédigez un titre d’au moins 5 caractères',
        },
        review: {
          label: 'Rédigez votre évaluation',
          placeholder_1_2:
            'Quels problèmes avez-vous rencontrés ? Que faudrait-il améliorer ? Vos commentaires contribueront à améliorer le produit et aideront les autres consommateurs à décider s’il leur convient.',
          placeholder_3:
            "Parlez-nous de votre expérience avec le produit. Qu'avez-vous apprécié et comment l'amélioreriez-vous pour le rendre plus attrayant ?",
          placeholder_4:
            "Décrivez votre expérience avec le produit. Qu'avez-vous le plus apprécié ? Pourquoi le recommanderiez-vous ? ",
          placeholder:
            "Partagez votre expérience après avoir testé le produit. Qu'avez-vous aimé ou moins aimé et pourquoi ? Le recommanderiez-vous ? Décrivez-nous ses détails, son utilisation et ses caractéristiques.",
          error: 'Rédigez un avis d’au moins 25 caractères',
          submitError:
            'Une erreur technique est survenue, veuillez réessayer dans quelques instants. Si le problème persiste, veuillez vous connecter à nouveau',
        },
        reviewTitle: {
          placeholder_1_2: 'Pourquoi votre expérience avec ce produit a-t-elle été mauvaise ?',
          placeholder_3: 'Quels aspects du produit amélioreriez-vous ?',
          placeholder_4: 'Quels sont les points forts de ce produit ?',
          placeholder: 'Résumez votre expérience avec le produit',
        },
        submit: 'Suivant',
      },
    },
    legacy: {
      cookies: {
        banner: 'Gérer mes cookies',
      },
      banners: {
        feedback: {
          title: 'Nous sommes en phase de tests !',
          open: 'Aidez-nous ',
          text: 'Pour nous améliorer, envoyez-nous vos commentaires à <br /><link1>contact@communaute-testerdesproduits.com</link1>!',
        },
      },
      modals: {
        shop: {
          title: 'Et voilà !!!',
          p1: 'Découvrez maintenant les produits que vous pouvez tester gratuitement :-)',
          p2: "Il ne vous reste plus qu'à choisir les produits qui vous plaisent dans la liste des produits disponibles dans votre magasin.",
          p3: 'Qu’est-ce que vous attendez ?',
        },
      },
      option: {
        yes: 'Oui',
        no: 'Non',
        dontKnow: 'Sans réponse',
        pets: {
          dog: 'Chien',
          cat: 'Chat',
          bird: 'Oiseau',
          mouse: 'Rongeur',
          fish: 'Poisson',
          others: 'Autre',
        },
      },
      header: {
        textLogo: 'Ma Communauté',
        invitations: 'Produits à tester',
        orders: 'Mes coupons',
        evaluations: 'Récupérer mes crédits',
        burgerTitle: 'Mes produits',
        products: 'Avis Clients',
        toStart: 'MonAvisLeRendGratuit',
        credits: 'crédits',
        profile: 'Mon profil',
        favorites: 'Favoris',
        additionalCredits: 'Crédits additionnels',
        economy: 'Économies réalisées',
        logout: 'Se déconnecter',
      },
      urls: {
        landing: {
          title_1: 'MonAvisLeRendGratuit a déménagé ',
          title_2: 'sur la Communauté Carrefour.',
          parragraph_1_1: 'Retrouvez votre programme ',
          parragraph_1_2: 'MonAvisLeRendGratuit ',
          parragraph_1_3: 'avec tous ses bénéfices en rejoignant la ',
          parragraph_1_4: 'Communauté Carrefour.',
          parragraph_2: 'Créez votre compte en utilisant vos identifiants MonAvisLeRendGratuit 😊',
          parragraph_3: 'Vous pourrez :',
          parragraph_4:
            'Consulter les informations légales applicables à cette nouvelle étape du programme en cliquant sur les liens suivants :',
          btn: 'Je rejoins la Communauté!',
          list_1: 'continuer de tester des produits gratuits',
          list_2: 'échanger avec les membres de la communauté au travers de publications ou par messages privés',
          list_3: 'participer à des jeux, concours, missions',
          list_4: 'et bien plus encore',
          list_5: 'Conditions Générales d’Utilisation',
          list_6: 'Politique de confidentialité',
        },
        howItWorks: {
          title: 'Comment ça marche ?',
          subtitle: 'Testez gratuitement plein de produits',
        },
        shopsParticipants: {
          title: 'Magasins participants',
          results: ' résultats pour votre recherche',
          subtitle:
            'Retrouvez tous les magasins Carrefour participants au programme MonAvisLeRendGratuit dans lesquels vous pourrez choisir vos produits gratuits, retirer et utiliser vos coupons.',
          tableTitle: 'Département {{code}} - {{name}}',
          placeholder: 'Ville, code postal...',
        },
        notFound: {
          title: "Oups ! La page que vous recherchez n'existe pas.",
          subtitle: 'Nous sommes désolés mais ce lien est introuvable, dirigez-vous vers la ',
          link: "page d'accueil",
        },
        shop: {
          notFound: 'JE NE TROUVE PAS MON MAGASIN HABITUEL',
          type: {
            placeholder: 'Sélectionnez votre enseigne',
            label: 'Enseigne',
            prefix: 'Carrefour',
          },
          reason: {
            placeholder: 'Indiquez-nous votre magasin',
            label: 'Nom de votre magasin habituel',
          },
          title: 'Bienvenue sur MonAvisLeRendGratuit !',
          btn: 'Suivant',
          btnContinue: 'Choisir un autre magasin',
          btnGo: 'Retour à la Communauté',
          btnSend: 'Envoyer',
          success: 'Votre magasin Carrefour a correctement été enregistré.',
          description:
            'Afin de vous proposer les produits disponibles à tester gratuitement dans votre magasin, veuillez  ' +
            'renseigner votre département et sélectionner votre magasin Carrefour parmi nos ' +
            '<link1>magasins participants</link1>.',
        },
        profile: {
          dietOptions: {
            omnivorous: 'Omnivore (régime comprenant des aliments d’origine végétale et animale)',
            vegetarian: 'Végétarien (régime alimentaire excluant toute chair animale- viande, poisson)',
            vegan: 'Vegan ou végétalien (régime alimentaire excluant tout aliment d´origine animale)',
            rawFood: 'Crudivore (régime alimentaire consistant à ne consommer que des aliments crus)',
            flexitarian: 'Fléxitarien (régime alimentaire consistant à limiter sa consommation de viande)',
            other: 'Autre',
          },
          allergiesOptions: {
            milk: 'Lactose (lait de vache et produits à base de lait)',
            crustaceans: 'Crustacés et produits à base de crustacés',
            eggs: "Œufs et produits à base d'oeufs",
            treeNuts:
              'Fruits à coques (amandes, noisettes, noix, noix de cajou, pécan, macadamia, du Brésil, du Queensland, pistaches) et produits à base de ces fruits',
            gluten: 'Gluten (blé et autres céréales contenant du gluten), et produits à base de ces céréales',
            fish: 'Poisson et produits à base de poisson',
            peanuts: 'Arachides et produits à base d’arachide',
            soybeans: 'Soja et produits à base de soja',
            celery: 'Céleri et produits à base de céleri',
            mustard: 'Moutarde et produits à base de moutarde',
            sesameSeeds: 'Graines de sésame et produits à base de graines de sésame',
            sulfurDioxideAndSulfites: 'Dioxyde de soufre et sulfites',
            lupine: 'Lupin et produits à base de lupin',
            molluscs: 'Mollusques et produits à base de mollusques',
          },
          title: {
            personalInfo: 'Mes informations personnelles',
            personalData: 'Mes données personnelles',
            phone: 'Numéro de téléphone',
            familyMembers: 'Composition du ménage',
            dietHabits: 'Profil alimentaire',
            pets: 'Avez-vous un animal de compagnie ?',
            alcohol: 'Acceptez-vous de tester des boissons alcoolisées ?',
          },
          labels: {
            gender: 'Civilité',
            diet: 'Quel est votre type de régime alimentaire ? (*)',
            allergies: 'Est-ce que vous ou un membre de votre foyer souffrez d’une allergie alimentaire ?',
            name: 'Prénom',
            lastname: 'Nom',
            email: 'Email',
            dob: 'Date de naissance',
            phone: 'Numéro de téléphone portable',
            submit: 'Enregistrer',
          },
          placeholder: {
            dob: 'dd/mm/aaaa',
            phone: 'Numéro de téléphone portable',
          },
          unsub: 'Je souhaite me désinscrire',
          gender: {
            man: 'Monsieur',
            woman: 'Madame',
          },
          childSelect: {
            placeholder: 'Combien d’enfants vivent dans votre foyer?',
            label: 'Combien d’enfants vivent dans votre foyer?',
          },
          policies: {
            all: "J'accepte tout.",
            general:
              "J'ai lu et j'accepte les Conditions Générales du Programme et la Politique de Confidentialité de “MonAvisLeRendGratuit”.",
            generalLinks:
              "J'ai lu et j'accepte les <link1>Conditions Générales du Programme</link1> et la <link2>Politique de Confidentialité</link2> de “MonAvisLeRendGratuit”.",
            communicationMail:
              "Oui, j'accepte de recevoir des promotions et offres spéciales de “MonAvisLeRendGratuit” par voie électronique.",
            notShuffleConnectionPolicy:
              'Je n’autorise pas Carrefour à communiquer mes données d’achats réalisées avec les cartes fidélité Carrefour associées au programme MonAvisLeRendGratuit',
          },
          validation: {
            genderRequired: 'Veuillez indiquer votre civilité',
            dobRequired: 'Veuillez indiquer votre date de naissance',
            dobMinimAge: 'Vous devez avoir plus de 18 ans',
            dobFormat: 'Le format de la date est incorrect',
            dobInvalid: 'Veuillez indiquer une date de naissance correcte',
            dobChildRequired: 'Veuillez indiquer la date de naissance',
            phoneRequired: 'Veuillez indiquer votre numéro de téléphone portable',
            phoneLength: 'Le numéro doit comporter 10 chiffres',
            familyMembersRequired: 'Veuillez indiquer si des enfants vivent dans votre foyer',
            petsRequired: 'Veuillez indiquer si vous avez un animal de compagnie',
            allergiesRequired: 'Veuillez indiquer si vous souffrez d’une allergie alimentaire',
            dietRequired: 'Veuillez indiquer votre type de régime alimentaire',
            petsAtLeastOneRequired: 'Veuillez indiquer au moins un animal de compagnie',
            allergiesAtLeastOneRequired: 'Veuillez indiquer au moins une allergie alimentaire',
            alcoholRequired: 'Veuillez indiquer si vous acceptez de tester des boissons alcoolisées',
          },
          notification: {
            success: 'Vos informations ont correctement été enregistrées',
            error: '',
          },
        },
        profileFirst: {
          title_step_1: 'Nous souhaiterions mieux vous connaître !',
          title_step_2: 'Nous souhaiterions mieux vous connaître !',
          title_step_3: 'Nous avons bientôt terminé !',
          text_step_1:
            'Pour récupérer vos crédits, nous allons vous demander quelques informations qui vont nous permettre de vous proposer des produits adaptés à votre profil.',
          step1: {
            title: 'Mes données personnelles',
            info: "En renseignant votre date de naissance, vous pourrez tester des produits proposés par les marques pour un certain groupe d'âge.",
          },
          step2: {
            title: 'Composition du ménage',
            info: 'Savez-vous que vous pouvez tester des produits infantils ainsi que des produits pour animaux de compagnie ? Si cela vous intéresse, indiquez-le nous !',
          },
          step3: {
            title: 'Profil alimentaire',
            info: 'Connaître votre profil alimentaire nous permet de vous proposer des produits spécifiques et votre avis précieux aide les marques à les améliorer !',
          },
        },
        promotions: {
          title: 'produits gratuits',
          favorites: 'produits favoris',
          additionalReward:
            'Obtenez 450 crédits en quelques clics ! C’est simple, UNE SEULE évaluation et ils sont à vous !',
          scriptRunning: 'Merci de patienter, nous recherchons les produits adaptés à votre profil',
          syncText:
            'Vous avez un compte sur la Communauté Carrefour et vous ne retrouvez pas les informations que vous aviez sur MonAvisLeRendGratuit (crédits, informations personnelles…) ? <link1>Cliquez ici</link1>.',
          labelCredits: 'crédits',
          emptyFav: {
            title: 'Aucun produit favori disponible',
            text1: 'Vos produits 🩷 ont expiré ou vous n’en avez pas encore ajouté.',
            text2: 'Parcourez nos nouveautés et ajoutez-les à votre liste !',
            button: 'Voir les produits disponibles',
          },
          empty: {
            title: 'Nous sommes désolés',
            description:
              'Le stock de produits participants au programme est momentanément épuisé, mais restez attentif, il y en aura peut-être dans les prochains jours.',
            error:
              'Nous avons un problème technique pour afficher vos produits gratuits, veuillez réessayer dans quelques instants.',
            blocked:
              "Nous avons détecté un problème avec votre compte. Pour plus d'informations, veuillez nous contacter via notre formulaire de contact.",
          },
          syncPopup: {
            title: 'Association de vos comptes',
            response: {
              done: 'Vous pouvez désormais accéder à toutes vos informations.',
              notValid:
                "L'adresse email insérée n'est pas valide soit car celle-ci se trouve être votre ancienne adresse soit car elle ne correspond pas au format type d'adresse email.",
              inUse: "L'adresse email insérée n’est pas valide ou est déjà utilisée",
              notFound:
                "L'adresse mail que vous avez indiquée est introuvable. Assurez-vous de saisir la bonne adresse mail.",
            },
          },
          pagination: {
            actual: 'Page {{n}} de {{total}}',
            previous: 'Précédente',
            next: 'Suivante',
          },
          filters: {
            cta: 'Filtres',
            noResults: 'Oups, rien trouvé par ici !',
            banner: 'Filtres mis à jour ! Découvrez-les vite ☝️',
            titles: {
              gp: 'Grand Prix De L´Innovation',
              mdc: 'Les trophées Carrefour',
              fav: 'Favoris',
              credits: 'Crédits',
              creditsCan: 'Crédits disponibles uniquement',
              categories: 'Catégories',
              sort: 'Trier par',
            },
            labels: {
              gp: 'Produits Participants',
              credits: 'Crédits',
              creditsAsc: 'Crédits croissants',
              creditsDesc: 'Crédits décroissants',
            },
            buttons: {
              reset: 'Effacer',
              submit: 'Voir les {{n}} produits à tester',
              noResults: 'Aucun produit à tester',
              resetAll: 'Effacer tout',
              viewAll: 'Voir tous',
              viewInvitations: 'Voir tous les articles',
            },
          },
          search: {
            placeholder: 'Rechercher par produit ou catégorie',
          },
          favs: {
            cta: 'Voir plus',
            thinText: 'Voir plus de produits à ajouter à vos favoris ☝️',
          },
        },
        promotionDetail: {
          title: 'Détail de la promotion',
          titleHD: 'Détail de la promotion à domicile',
          back: 'retour',
          ean: 'Code produit :',
          redeemButton: 'Demander le coupon',
          finishButton: 'Finaliser',
          legalText:
            '* Pour retirer ce produit gratuit, vous devez faire un achat minimum de 30 euros, ce montant ne comprenant pas' +
            ' les produits MonAvisLeRendGratuit. Seuls les achats portant sur des Produits de Grande Consommation, incluant notamment les produits alimentaires,' +
            ' sont pris en compte pour atteindre ce minimum.  Vous pouvez utiliser jusqu’à 4 coupons différents par passage en caisse. ',
          parapharmacieText:
            "* Pour bénéficier gratuitement des produits de la parapharmacie, un minimum de 30€ d'achat dans ce rayon est nécessaire, ce montant ne comprenant pas les produits MonAvisLeRendGratuit.",
          sideListTitle: 'Produits à tester',
          cardSelect: {
            indexTitle: 'Demandez votre produit gratuit !',
            indexSubtitle: 'Pour pouvoir générer votre coupon, nous avons besoin de votre numéro de carte Carrefour.',
            selectLabel: 'Carte Carrefour',
            selectPlaceholder: 'Choisissez la carte Carrefour',
            title: 'Choisissez la carte avec laquelle vous voulez retirer le produit en magasin',
            subtitle:
              'Vous devez utiliser uniquement la carte choisie lors de votre passage en caisse. En continuant, vous confirmez que vous utiliserez cette carte en magasin pour retirer le produit',
          },
          firstCycle:
            "Demandez ce produit rapidement avant qu’il ne s'épuise, vous avez 7 jours pour le retirer dans votre magasin !",
          isLastMinute:
            'Attention, ce produit ne sera bientôt plus disponible, vous avez jusqu’à {{fullDate}} pour aller le retirer dans votre magasin.',
          noCardsAvailable:
            "La carte que vous avez dans votre profil a déjà demandé cette promotion. Il n'est pas possible de continuer.",
          homeDelivery: {
            legalText:
              'Cliquez sur « Demander le produit », répondez à quelques questions et recevez le produit directement chez vous !',
          },
        },
        communityAndShop: {
          title: 'Mon magasin Carrefour',
          titleSuccess: 'Merci !',
          subtitle:
            'Introduisez votre département puis sélectionnez votre magasin parmi tous les magasins participants.',
          subtitleWhenSuccess: 'Vous pouvez choisir un autre magasin pour profiter de produits gratuits.',
          subtitleSuccess:
            'Nous vous informerons quand votre magasin participera au programme. En attendant, vous pouvez choisir un autre magasin pour profiter de produits gratuits.',
          selectLabel: 'Département',
          selectPlaceholder: 'Choisissez votre département',
          shopsTitle: 'Voici les magasins participants les plus proches de vous',
          extraInfo:
            '(*) Vous êtes sur le point de changer le magasin associé à votre compte. Si vous modifiez ' +
            'cette information, vous perdrez tous les produits qui vous sont actuellement proposés.' +
            ' Si vous souhaitez continuer, vous recevrez rapidement de nouveaux produits à demander ' +
            'dans votre nouveau magasin.',
          edit: 'modifier',
          cancel: 'annuler',
        },
        loyaltyCards: {
          title: 'Mon Club Carrefour',
          subtitle:
            "J'enregistre ma Carte Club Carrefour ou ma Carte PASS afin de pouvoir demander des produits gratuits.",
          select: 'Sélectionnez votre Carte Club Carrefour ou Carte PASS',
          cancel: 'annuler',
          delete: 'éliminer',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer votre carte ?',
          deleting: {
            success: 'Votre carte a correctement été supprimée',
            genericError:
              "Un problème technique est survenu. Si cela persiste, veuillez envoyer au Service Client de MonAvisLeRendGratuit une capture d'écran de cette erreur.",
          },
          creating: {
            success: 'Votre Carte a été correctement enregistrée',
            notValid: "Ce numéro de carte de fidélité n'est pas valide",
            duplicated:
              'Ce numéro est déjà associé à un client, veuillez prendre contact avec le Service Client de MonAvisLeRendGratuit pour associer ce numéro à votre compte.',
            genericError:
              "Un problème technique est survenu. Si cela persiste, veuillez envoyer au Service Client de MonAvisLeRendGratuit une capture d'écran de cette erreur.",
          },
          caption: {
            crf: 'Ma Carte Club Carrefour (*)',
            pass: 'Ma Carte PASS Mastercard (*)',
            add: 'Créer ma carte (*)',
          },
          error_duplicate_card:
            'Ce numéro est déjà associé à un client, veuillez prendre contact avec' +
            ' le Service Client de MonAvisLeRendGratuit pour associer ce numéro à votre compte.',
          placeholder: {
            crf: 'nº de carte (13 chiffres)',
            pass: 'nº de carte PASS Mastercard (16 chiffres)',
          },
          register: {
            crf: 'Enregistrez votre Carte Club Carrefour',
            crfInfo:
              'Vous possédez déjà une carte : saisissez les chiffres situés sur votre carte.\n' +
              'Pour vous aider, les 6 premiers numéros sont déjà renseignés.',
            pass: 'Enregistrez votre carte PASS Mastercard',
            passInfo:
              'Vous possédez une Carte PASS Mastercard : saisissez les chiffres situés comme indiqué dans l’image.',
            submit: 'Vérifier ma carte',
            success: 'Votre Carte Carrefour a été correctement enregistrée.',
          },
          errors: {
            lengthCrf: 'Veuillez introduire un numéro de 13 chiffres',
            lengthPass: 'Veuillez introduire un numéro de 16 chiffres',
            required: 'Veuillez introduire un numéro de carte',
            format: 'Veuillez introduire un numéro',
          },
          list: {
            mainTitle: 'Carte principale :',
            othersTitle: 'Autres cartes :',
          },
        },
        cardSelect: {
          title: 'Ma carte Carrefour',
          success: {
            title: 'Merci beaucoup ',
            titleAside: 'Votre produit',
            btn: 'Finaliser',
            text: 'Votre Carte Carrefour a correctement été enregistrée. Cliquez sur "Finaliser" pour finaliser votre demande et pouvoir demander d\'autres produits à tester.',
          },
        },
        profileSuccess: {
          success: {
            title: 'Merci beaucoup ',
            titleAside: 'Votre produit',
            btn: 'Finaliser',
            text: 'Cette fois, vous devez seulement cliquer sur "Finaliser" pour récuperer vos crédits. La prochaine fois, nous vous demanderons d\'évaluer le produit.',
          },
        },
        router: {
          error: {
            title: 'Oups !',
            button: 'Retour à la liste de produits',
          },
        },
        coupons: {
          title: 'Détail du coupon',
          empty: {
            title: 'Vous trouverez dans cette rubrique vos produits demandés, prêts à être retirés en magasin.',
            description:
              'Vous n’avez pas de demandes en cours. N’hésitez pas à vous rendre sur la rubrique « Produits ' +
              'à tester » afin de demander les produits qui vous plaisent !',
          },
          titleAside: 'Mes coupons',
          btn: 'Télécharger en PDF',
          label: {
            coupon: 'Code Coupon',
            ean: 'Code Produit',
            shop: 'Coupon à utiliser uniquement dans le magasin',
            card: 'Carte ou Carte PASS n°',
            username: 'Offre réservée à',
            expired: "Valable jusqu'au",
          },
          legal: {
            coupon:
              'Pour bénéficier de cette offre, vous devez réaliser 30€ d’achat, ce montant ne comprenant pas les produits MonAvisLeRendGratuit. Seuls les achats portant sur des Produits de Grande Consommation, incluant notamment les produits alimentaires, sont pris en compte pour atteindre ce minimum.',
            parapharmacie:
              "* Pour bénéficier gratuitement des produits de la parapharmacie, un minimum de 30€ d'achat dans ce rayon est nécessaire, ce montant ne comprenant pas les produits MonAvisLeRendGratuit.",
            extended:
              '* Hors Cartes Cadeaux et Services (carburant, drive, téléphonie, espace Voyages, billetterie spectacles, assurances, services financiers, vidange et soins auto,' +
              ' et hors stations autoroute Carrefour, hors achats sur le site online Vos Courses en ligne (Drive, Livraison à Domicile) avec Carrefour.fr )' +
              ' Vous pouvez utiliser jusqu’à 4 coupons différents « MonAvisLeRendGratuit », par passage en caisse. Un seul coupon par produit et par' +
              ' foyer sera accepté en caisse. Offre valable dans la limite des quantités disponibles. ',
            homeDelivery: {
              title: 'Merci pour votre participation !',
              info: 'Dans les prochains jours, vous recevrez le produit directement chez vous. Nous vous remercions par avance de le tester et de partager ensuite votre avis. Vos retours sont précieux, en particulier pour de nouveaux produits en lancement.',
            },
          },
        },
        evaluations: {
          empty: {
            title: "Dans cette section vous trouverez vos produits en attente d'être évalués.",
            description:
              'Vous n’avez pas d’évaluations en attente. N´hésitez pas à vous rendre sur la rubrique ' +
              '« Produits à tester » afin de demander les produits qui vous plaisent !',
          },
          list: {
            title: 'Récupérer mes crédits',
            info1: 'Évaluez les produits que vous avez testés et RÉCUPÉREZ VOS CRÉDITS.',
            info2:
              "Prenez quelques minutes pour évaluer le produit que vous avez testé et vous récupérerez les crédits utilisés pour l'achat de ce produit.",
            info3:
              'Merci de répondre de la façon la plus objective et la plus sincère possible, nous vous en serons reconnaissants.',
            info4: "L'évaluation est disponible dans un délai de 48h après le retrait du produit en magasin.",
            additionalReward:
              "Si vous n'avez encore jamais évalué de produit, remplissez votre toute <strong>première</strong> évaluation et recevez 300 crédits supplémentaires en plus du remboursement de vos crédits pour ce produit.",
          },
          detail: {
            label: {
              date: 'Quand êtes vous allé au magasin?',
            },
            homeDelivery:
              'Une fois le produit reçu chez vous, vous disposerez de quelques jours pour le tester, puis vous pourrez l’évaluer ici.',
            initial: 'Avez-vous déjà retiré le produit en magasin ?',
            initialYes: "Oui, j'ai utilisé le coupon",
            initialNo: "Non, je n'ai pas utilisé le coupon",
            goBack: 'annuler',
            redemption:
              "Pour confirmer que vous avez retiré le produit, s'il vous plaît complétez l'information suivante :",
            cancel: "Veuillez nous indiquer pourquoi vous n'avez pas utilisé le coupon",
            cancelReasons: {
              1: 'Je n’ai pas trouvé le produit / Il n’y en avait pas dans le rayon',
              2: 'J’ai oublié de retirer le produit',
              3: 'J’ai décidé de ne pas retirer le produit',
              4: 'Le coupon n’est pas passé en caisse',
              5: 'Autres raisons',
            },
            cancelSubmit: "J'annule le coupon",
            cancelErrorSelectOne: 'Veuillez sélectionner la raison de votre annulation',
            orderCancelSubmit: 'Valider',
            cancelSuccess: 'Votre coupon a correctement été annulé',
            cancelErrorMessage: 'Oups, une erreur technique est survenue, cette action ne peut pas être réalisée',
            evaluate: "J'ai retiré le produit en magasin et je peux l'évaluer pour récupérer mes crédits",
            evaluateSubmit: "J'évalue le produit",
            clockMessage:
              'Pour vous laisser le temps de tester ce produit, vous pourrez donner votre avis dans {{time}}',
            genericError: 'Un problème technique est survenu, veuillez réessayer dans quelques instants',
          },
        },
        callback: {
          loading: 'Une petite minute, nous sommes en train de rechercher les informations à montrer',
          loadingRefresh: 'Veuillez ne pas rafraîchir la page',
          errorTitle: 'Oups !',
          errorState: "La connexion à votre compte Carrefour n'a pas pu être établie",
          errorText: 'Un problème technique est survenu, veuillez réessayer dans quelques instants',
          button: "J'essaie encore",
        },
        register: {
          title: 'S’inscrire',
          subtitle: 'Testez gratuitement plein de produits. Comment ça marche ?',
          steps: {
            1: 'Acceptez les conditions légales et recevez 450 crédits',
            2: 'Choisissez votre magasin habituel',
            3: 'Sélectionnez les produits que vous souhaitez tester',
            4: 'Échangez vos coupons contre des produits',
            5: 'Testez vos produits et donnez votre opinion...',
          },
          conditions: {
            title: 'Conditions Légales et Politique de Confidentialité',
            info:
              'Il semblerait que vous soyez nouveau sur la plateforme "MonAvisLeRendGratuit". Pour continuer et ' +
              'bénéficier de produits gratuits, vous devez être majeur et accepter les <link1>Conditions Générales du Programme</link1> et la ' +
              '<link2>Politique de Confidentialité</link2> de “MonAvisLeRendGratuit”.',
            infoUx:
              'Vous êtes nouveau sur notre plateforme. Pour continuer et bénéficier de produits gratuits, vous devez être majeur et accepter les ' +
              '<link1>Conditions Générales du Programme</link1> et la <link2>Politique de Confidentialité</link2> de “MonAvisLeRendGratuit”.',
            checkAccept:
              "J'ai lu et j'accepte les Conditions Générales du Programme et la Politique de Confidentialité de “MonAvisLeRendGratuit”.",
            checkCommunications:
              "Oui, j'accepte de recevoir des promotions et offres spéciales de “MonAvisLeRendGratuit”  par voie électronique.",
            required: 'Vous devez accepter les mentions légales.',
          },
          ageCheck: {
            title: "Je confirme que j'ai plus de 18 ans.",
            required: 'Vous devez avoir 18 ans pour vous inscrire.',
          },
          pixel: {
            title:
              "J'accepte que l'ouverture de mes e-mails soit analysée afin de mesurer les performances des communications et de personnaliser les contenus qui me sont envoyés.",
          },
          submit: 'Suivant',
        },
        survey: {
          pre: {
            headerMobile: "Produit en cours d'évaluation:",
            success: {
              withDate:
                "Votre coupon a correctement été généré, vous avez jusqu'au {{fullDate}} (inclus) pour aller retirer le produit dans le magasin sélectionné.",
              tomorrow:
                "Votre coupon a correctement été généré, vous avez jusqu'à demain (inclus) pour aller retirer le produit dans le magasin sélectionné.",
              today:
                "Votre coupon a correctement été généré, vous devez retirer le produit aujourd'hui dans le magasin sélectionné.",
              homeDelivery:
                'Merci pour votre participation ! Dans les prochains jours, vous recevrez le produit directement chez vous.',
            },
          },
          post: {
            headerMobile: "Produit en cours d'évaluation:",
          },
          external: {
            error: "Vous n'avez aucune enquête à remplir",
            success: "Merci beaucoup d'avoir répondu à cette enquête d'une manière sincère.",
            back: 'Retour',
          },
        },
        start: {
          steps: {
            one: {
              normal: 'Sélectionnez les produits',
              bold: 'à tester',
            },
            two: {
              bold: 'Retirez vos produits',
              normal: 'en magasin',
            },
            three: {
              bold: 'Donnez votre avis',
              normal: 'et recommencez !',
            },
          },
          link: 'Commencer',
          shop: 'Consultez la liste des <link1>magasins participants</link1>. Achat minimum de 30 € requis hors produits MonAvisLeRendGratuit.',
          login: 'Accédez à MonAvisLeRendGratuit en <link1>cliquant ici</link1>.',
          extra:
            "*Les produits illustrés ne sont pas nécessairement inclus dans la promotion et sont uniquement à titre d'exemple.",
        },
        saz: {
          title: 'Avis Clients by Shopadvizor',
          noResultsText: 'Nous sommes désolés, aucun résultat ne correspond à votre recherche',
          text: 'Shopadvizor vous aidera à choisir au mieux vos produits grâce à l’information de leur composition et aux notes et avis laissés par des milliers de consommateurs.',
        },
        shuffle: {
          title: 'Pour continuer, évaluez quelques produits que vous avez achetés ces derniers mois.',
          subtitle: 'Votre opinion sincère et objective aide la communauté à mieux consommer !',
        },
      },
      errors: {
        order: {
          validation: {
            noInvitation: "Vous ne possédez pas d'invitation correspondant à ce produit",
            noCredits: 'Oups ! Vous ne disposez pas de suffisamment de crédits pour demander ce produit.',
            reachedLimit: 'Vous ne pouvez pas demander plus de 4 produits',
            ack: {
              10: 'Ce produit n’est plus disponible',
              30: 'Veuillez évaluer vos produits retirés pour pouvoir profiter d’autres offres',
              31: 'Vous n’avez pas suffisamment de crédits pour demander ce coupon, vous pouvez récupérer vos crédits en évaluant vos produits',
              32: 'Un problème est survenu. Afin de garantir le bon fonctionnement de la plateforme, veuillez ne pas utiliser la navigation privée ou autorisez les cookies tiers dans les paramètres de votre navigateur. <link1>Comment faire</link1> ?',
              33: 'Un problème est survenu. Afin de garantir le bon fonctionnement de la plateforme, veuillez ne pas utiliser la navigation privée ou autorisez les cookies tiers dans les paramètres de votre navigateur. <link1>Comment faire</link1> ?',
              34: 'Zut ! Le stock du produit est épuisé, nous ne pourrons pas vous l’envoyer. Restez à l’affût de nos prochains envois à domicile !',
              111: 'Afin d’obtenir votre premier coupon, veuillez renseigner votre magasin habituel',
              112: 'Afin d’obtenir votre premier coupon, veuillez renseigner votre Carte Carrefour',
              199: 'Une erreur technique est survenue, veuillez réessayer dans quelques instants. Si le problème persiste, veuillez vous connecter à nouveau',
              299: 'Veuillez vous connecter à nouveau',
              404: 'Ce produit n’est plus disponible',
              110: "Vous ne pouvez pas accéder à l'url demandée",
              113: 'Ce produit n’est plus disponible',
              114: "Votre session est expirée en raison d'une absence d'activité",
              115: "Le stock de ce produit est épuisé au sein du programme MonAvisLeRendGratuit. Cliquez sur Produits à tester pour découvrir d'autres produits disponibles.",
              116: "Nous avons détecté un problème avec votre compte. Pour plus d'informations, veuillez nous contacter via notre formulaire de contact.",
              117: 'Erreur de code-barres',
              118: 'Il existe déjà une demande pour ce produit',
              119: "Vous ne possédez pas d'invitation correspondant à ce produit",
              120: 'Il existe déjà une demande pour ce produit',
              121: ' ERROR_API_COUPON',
              122: ' NO_CARD_WITH_COREPRO/NO_CARD_WITH_COREPRO_APP',
              123: ' COM_ORDERS_NOCREATE',
              124: 'Un problème est survenu avec votre compte utilisateur, veuillez prendre contact avec le Service Client.',
              200: 'Votre coupon a correctement été généré, vous avez 7 jours pour aller retirer le produit dans le magasin que vous avez sélectionné.',
              201: 'Votre coupon a correctement été généré, vous avez 7 jours pour aller retirer le produit dans le magasin que vous avez sélectionné.',
              202: 'Merci, vous avez correctement récupéré vos crédits',
            },
          },
          btn: {
            ack: {
              10: 'Demander le coupon',
              30: "OK j'évalue mes produits",
              31: "OK j'évalue mes produits",
              34: 'Produit épuisé',
              111: 'OK je renseigne mon magasin',
              112: 'OK je renseigne ma Carte Carrefour',
              199: 'Demander le coupon',
              299: 'Demander le coupon',
              404: 'Demander le coupon',
            },
          },
        },
      },
      component: {
        expirationClock: {
          days: '{{days}} jours',
          tomorrow: 'Demain',
          today: "Aujourd'hui",
        },
        serverDown: {
          errorTitle: 'Oups !',
          errorText: 'Un problème technique est survenu, veuillez réessayer dans quelques instants',
          button: "J'essaie encore",
        },
        idled: {
          errorTitle: 'Oups !',
          errorText:
            'Nos produits gratuits sont victimes de leur succès, et il y a une file d’attente de quelques minutes.',
          errorText2: 'Veuillez réessayer dans quelques instants.',
          button: 'Recharger',
        },
        underMaintenance: {
          errorText1: 'Bonjour à tous,',
          errorText2: 'Notre équipe technique est en train d’améliorer le fonctionnement de votre site.',
          errorText3:
            'Pour cette raison, le site est en cours de maintenance et sera rétabli dans les meilleurs délais. Nous nous excusons pour la gêne occasionnée et vous remercions de votre patience et de votre compréhension.',
          button: 'Rafraîchir la page',
        },
        redemptionDate: {
          error: {
            NO_REQUEST_DATE: 'Veuillez indiquer une date',
            NO_INPUT_DATE: 'Veuillez indiquer une date',
            NO_INPUT_VALID_DATE: 'Veuillez indiquer une date valide',
            DATE_BEFORE: 'La date introduite ne doit pas être antérieure à la date de la demande',
            DATE_AFTER: 'La date introduite ne doit pas être postérieure à aujourd’hui',
          },
        },
        pdf: {
          shopTitle: 'Coupon à utiliser uniquement dans le magasin :',
          preDate: 'Vous avez jusqu’au',
          postDate: 'pour retirer ce produit',
          ean: 'Code produit',
          codeTitle: 'Pour bénéficier de la gratuité de ce coupon, veuillez présenter',
          codeCard: 'Votre Carte Carrefour ou Carte PASS n°',
          codeHelp: 'Le produit cité ci-dessus',
          legal1:
            '  Pour bénéficier de cette offre, vous devez réaliser 30€ d’achat, ce montant ne comprenant pas les produits MonAvisLeRendGratuit. Seuls les achats portant sur des Produits de Grande Consommation, incluant notamment les produits alimentaires, sont pris en compte pour atteindre ce minimum. ',
          legal2: '',
          legal3:
            '* Hors Cartes Cadeaux et Services (carburant, drive, téléphonie, espace Voyages, billetterie spectacles, assurances, services financiers,' +
            ' vidange et soins auto, et hors stations autoroute Carrefour, hors achats sur le site online Vos Courses en ligne (Drive, Livraison à Domicile)' +
            ' avec Carrefour.fr ) Vous pouvez utiliser jusqu’à 4 coupons différents « MonAvisLeRendGratuit », par passage en caisse.' +
            ' Un seul coupon par produit et par foyer sera accepté en caisse. Offre valable dans la limite des quantités disponibles.',
          legal4:
            "* Pour bénéficier gratuitement des produits de la parapharmacie, un minimum de 30€ d'achat dans ce rayon est nécessaire, " +
            'ce montant ne comprenant pas les produits MonAvisLeRendGratuit.',
        },
        footer: {
          HOW_IT_WORKS: 'Comment ça marche ?',
          SHOPS_PARTICIPANTS: 'Magasins participants',
          SITEMAP: 'Plan du site',
          FAQ: 'FAQ',
          LEGAL_CONDITION: 'Conditions Générales',
          COOKIES_POLICY: 'Politique en matière de cookies',
          CONFIDENTIAL_LEGAL: 'Politique de Confidentialité',
          CONTACT: 'Formulaire de contact',
        },
      },
      rewards: {
        firstEvaluation: 'Félicitations ! Vous avez reçu vos 450 crédits additionnels !',
        specialOctober24: 'Félicitations ! Vous avez reçu vos 300 crédits additionnels !',
      },
    },
    product: {
      infoButton: "Plus d'information",
      nutritionalValues: {
        title: 'Valeurs nutritionnelles',
        labels: {
          energy: 'Energie',
          fat: 'Grais. Sat.',
          sugar: 'Sucres',
          fiber: 'Fibres',
          protein: 'Protéines',
          proteins: 'Protéines',
          salt: 'Sel',
        },
      },
      allergens: 'Allergènes',
      allergensText: {
        milk_yes: 'Lactose',
        soybeans_yes: 'Soja',
        peanuts_yes: 'Arachide',
        celery_yes: 'Céleri',
        eggs_yes: 'Oeufs',
        molluscs_yes: 'Mollusques',
        tree_nuts_yes: 'Fruits à coque',
        fish_yes: 'Poisson',
        mustard_yes: 'Moutarde',
        sesame_seeds_yes: 'Sésame',
        sulfur_dioxide_and_sulfits_yes: 'Sulfites',
        lupine_yes: 'Lupin',
        crustaceans_yes: 'Crustacés',
        gluten_yes: 'Gluten',
        milk_traces: 'Traces de lactose',
        soybeans_traces: 'Traces de soja',
        peanuts_traces: "Traces d'arachide",
        celery_traces: 'Traces de céleri',
        eggs_traces: "Traces d'oeuf",
        molluscs_traces: 'Traces de mollusques',
        tree_nuts_traces: 'Traces de fruits à coque',
        fish_traces: 'Traces de poisson',
        mustard_traces: 'Traces de moutarde',
        sesame_seeds_traces: 'Traces de sésame',
        sulfur_dioxide_and_sulfits_traces: 'Traces de sulfites',
        lupine_traces: 'Traces de lupin',
        crustaceans_traces: 'Traces de crustacés',
        gluten_traces: 'Traces de gluten',
      },
      noInfo: "Désolé, nous n'avons pas encore cette information pour ce produit",
      noTraces: 'Ce produit ne contient aucun allergène',
      composition: 'Ingrédients / Composition',
      description: 'Description',
      nutritionalRange: {
        title: 'Valeurs nutritionnelles',
        subtitle: 'Comment lire les valeurs nutritionnelles ?',
        info: 'Retrouvez en un clin d’oeil les valeurs nutritionnelles des produits alimentaires. Les échelles de couleur sont là pour vous aider à savoir si vous devez limiter la consommation d’un produit ou au contraire la privilégier.',
      },
    },
    reviews: {
      title: 'Avis de consommateurs',
      comments: 'commentaires',
      years: 'ans',
      upToDate: '',
      commentDate: 'avis déposé :',
      purchasedDate: '/ achat :',
      order: {
        SortLastDate: 'Les plus récents',
        SortFirstDate: 'Les plus anciens',
        SortFirstRate: 'Les plus favorables',
        SortLastRate: 'Les moins favorables',
      },
    },
    mobile: {
      reviews: 'Avis de consommateurs',
      product: 'Composition',
    },
    pickupPoint: {
      promotionDateText_1: 'Les produits gratuits pour le magasin ',
      promotionDateText_2: ' seront disponibles à partir du ',
      promotionNullText_1: 'Le magasin ',
      promotionNullText_2:
        ' ne participe plus à MonAvisLeRendGratuit, pour pouvoir profiter de produits gratuits, veuillez sélectionner un autre magasin depuis votre profil ',
    },
    fastJourney: {
      thinText: '🎁\u202FOffre spéciale\u202F: vos produits en un clic.',
      thinTooltipText:
        'Pendant tout le mois d’octobre : demandez vos produits en un clic, sans remplir de questionnaires\u202F!',
      pre: {
        title: '🎁 Offre spéciale d’octobre',
        text1: 'Pendant tout le mois, demandez un produit et recevez directement votre coupon\u202F!',
        text2:
          'Dès le 1er novembre, le parcours habituel sera rétabli\u202F: il faudra remplir un questionnaire pour demander un produit.',
      },
      post: {
        title: '🎁 Offre spéciale d’octobre',
        text1:
          'Pendant tout le mois, il suffit de donner votre avis sur le produit testé pour récupérer vos crédits\u202F!',
        text2:
          'Dès le 1er novembre, le parcours habituel sera rétabli\u202F: vous devrez remplir un questionnaire pour récupérer vos crédits.',
      },
      firstPre: {
        title: "Pas d'enquête pour le premier produit !",
        text1: 'Rien à remplir cette fois-ci ! Lors de votre prochain coupon, une courte enquête vous sera demandée.',
      },
      firstPost: {
        title: "Pas d'enquête complète la première fois !",
        text1:
          'Veuillez maintenant compléter votre profil afin que nous puissions vous proposer des produits qui vous correspondent.',
        text2: 'Nous vous demanderons ensuite d’évaluer brièvement le produit pour récupérer vos crédits.',
      },
    },
  },
};

export default FranceTranslation;
